import { uuidV4 } from "./helpers";
import type { RaasEvent, RaasEventType } from "./types";

declare const __RAAS_EVENTS_BASE_URL__: string;

type SendFunction = (args: {
  type: RaasEventType;
  serpId: string;
  revAttChannels: string[];
}) => Promise<void>;

export const createEventsClient = (args: {
  tenantId: string;
  tenantKey: string;
}) => {
  const endpoint = `${__RAAS_EVENTS_BASE_URL__}/v1/${encodeURIComponent(args.tenantId)}`;
  const authHeader = `Bearer ${args.tenantKey}`;

  const send: SendFunction = async ({ type, serpId, revAttChannels }) => {
    const body: RaasEvent = {
      eventId: uuidV4(),
      clientTimestamp: new Date().toISOString(),
      type,
      serpId,
      channels: revAttChannels,
      href: window.location.href,
    };

    try {
      await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: authHeader,
        },
        body: JSON.stringify(body),
      });
    } catch {
      // best-effort
    }
  };

  return send;
};
